import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import AuthHeader from "components/layout/AuthHeader";

import AuthFooterLink from "commonComponents/AuthFooterLink";

const sx = {
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100vh"
  },

  main: {
    flexGrow: "1",
    overflow: "hidden"
  }
};

export default function Auth() {
  return (
    <Box sx={sx.root}>
      <AuthHeader />
      <Box sx={sx.main}>
        <Outlet style={{ flexGrow: "1" }} />
      </Box>
      <AuthFooterLink />
    </Box>
  );
}
